var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Routes from '../../routes/RoutesConfig';
import History from '../../services/History';
import Session from '../../services/Session';
import Signals from '../../signals/Signals';
import Command from '../Command';
/**
 *
 */
var LogoutCommand = /** @class */ (function (_super) {
    __extends(LogoutCommand, _super);
    function LogoutCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     */
    LogoutCommand.prototype.execute = function (redirectToLogin) {
        if (redirectToLogin === void 0) { redirectToLogin = true; }
        Session.setJWT(null);
        if (redirectToLogin)
            History.push(Routes.LOGIN.getPath());
        Signals.LoggedOut.dispatch();
        localStorage.clear();
    };
    return LogoutCommand;
}(Command));
export default LogoutCommand;
